export default __webpack_public_path__ + "static/media/vitra_chair_08.0ad0cab0.jpg";